// extracted by mini-css-extract-plugin
module.exports = {"legend":"RequestForm_legend__1nnQp components_largeText__1Rt50","formCardFieldset":"RequestForm_formCardFieldset__1zIb2","widgets":"RequestForm_widgets__2mw4j"};